import { render, staticRenderFns } from "./ApplyForAJob.vue?vue&type=template&id=dea36972&scoped=true&"
import script from "./ApplyForAJob.vue?vue&type=script&lang=js&"
export * from "./ApplyForAJob.vue?vue&type=script&lang=js&"
import style0 from "./ApplyForAJob.vue?vue&type=style&index=0&id=dea36972&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea36972",
  null
  
)

export default component.exports